module.exports = __webpack_public_path__ + "img/greenwich-g-series-rectangle-front-angle.e3ed5879.png";